import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BorrowerActionsSmartComponent } from './borrower-actions-smart/borrower-actions-smart.component';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { ScheduleReminderModule } from 'app/schedule-reminder/schedule-reminder.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ChangeAssignmentSmartModule } from '../change-assignment-smart/change-assignment-smart.module';
import { ShareBorrowerModule } from '../share-borrower/share-borrower.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ComplianceReviewDialogModule } from '../compliance-review-dialog/compliance-review-dialog.module';
import {BorrowerNameModule} from 'ng2-app/borrower-header/borrower-name/borrower-name.module';

@NgModule({
  declarations: [
    BorrowerActionsSmartComponent
  ],
    imports: [
        CommonModule,
        ChangeAssignmentSmartModule,
        ComplianceReviewDialogModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatDialogModule,
        MatTooltipModule,
        ScheduleReminderModule,
        ShareBorrowerModule,
        BorrowerNameModule,
    ],
  exports: [
    BorrowerActionsSmartComponent
  ]
})
export class BorrowerActionsModule { }
